import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";

import { ConsumerActions } from "../../actions/consumer.actions";
import { OrderCostStatsState } from "../../models/consumer/order-cost-stats-state";

const initialState: OrderCostStatsState = {
	loading: true
};

const reducer = createReducer(
	initialState,
	on(ConsumerActions.orderCostStats.getApi, (state) => ({ ...state, loading: true })),
	on(ConsumerActions.orderCostStats.getSuccess, (state, action) => ({
		..._.omit(state, "error"),
		..._.omit(action, "type")
	})),
	on(ConsumerActions.orderCostStats.getFail, (state, action) => ({
		...state,
		..._.omit(action, "type")
	}))
);

export function orderCostStatsReducer(
	state: OrderCostStatsState | undefined,
	action: Action
): OrderCostStatsState {
	return reducer(state, action);
}
